export function addLeadingZero(number) {
  return number < 10 ? '0' + number : number;
}

export function formatSinceLastScore(sinceLastScore) {
  if (!sinceLastScore || sinceLastScore === "" || sinceLastScore === " " || sinceLastScore === 0) {
    return '-';
  }

  const inputTimestamp = sinceLastScore * 1000; // Convert from seconds to milliseconds
  const currentTimestamp = Date.now();
  const differenceInMs = currentTimestamp - inputTimestamp;

  const differenceInMinutes = Math.floor(differenceInMs / (1000 * 60));
  const differenceInHours = Math.floor(differenceInMs / (1000 * 60 * 60));
  const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));

  if (differenceInMinutes < 60) {
    return `${differenceInMinutes}m`;
  } else if (differenceInHours < 24) {
    const hours = differenceInHours;
    const minutes = differenceInMinutes % 60;
    return `${hours}h ${minutes}m`;
  } else {
    const days = differenceInDays;
    const hours = differenceInHours % 24;
    const minutes = differenceInMinutes % 60;
    return `${days}d ${hours}h ${minutes}m`;
  }
}

export function formatTimestamp(timestamp) {
  if (!timestamp || timestamp === '-') {
    return '-';
  }

  const milliseconds = timestamp * 1000;
  const date = new Date(milliseconds);

  const day = date.getDate();
  const monthNames = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hour = addLeadingZero(date.getHours());
  const minute = addLeadingZero(date.getMinutes());
  const second = addLeadingZero(date.getSeconds());

  const formattedDateTime = `${day}/${month}/${year} ${hour}:${minute}:${second}`;

  return formattedDateTime;
}

export function getProperty(obj, path) {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
}